import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import AgendaPage from "./pages/AgendaPage";
import ErrorPage from "./pages/ErrorPage";
import './firebase.config'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:token" element={<HomePage />} />
          <Route path="/Agenda" element={<AgendaPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
